import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from 'antd'
import { ArrowDownIcon } from '../../../../../assets/icons/common/common-icons'
import { VaultFilterButton, CloseButton, FilterIconWrapper } from '../VaultFilters.styles'
import { CloseIcon } from '../icons'
import { TagsDropdown } from './TagsDropdown';
import { StatusDropdown } from './StatusDropdown';
import { PeriodDropdown } from './PeriodDropdown';
import { TagsFilterDrawer } from './TagsFilterDrawer'
import { PeriodFilterDrawer } from './PeriodFilterDrawer'
import { StatusFilterDrawer } from './StatusFilterDrawer'
import { useStore } from '../../../../app/data/root.store'
import { useAnalytics } from '../../../../app/data/AnalyticsProvider'

export const FilterButton = ({
    filter,
    isActive,
    hasDropdown,
    onRemove,
    children,
    disabled = false,
    onClickButton
}) => {
    const { uiStore, vaultStore } = useStore()
    const { mixpanelTrack } = useAnalytics()
    const buttonRef = useRef(null)
    const [dropdownVisible, setDropdownVisible] = useState(false)
    const [drawerVisible, setDrawerVisible] = useState(false)

    // Function to close dropdown on scroll
    useEffect(() => {
        if (!dropdownVisible) return;

        const handleScroll = (e) => {
            if (('tags-dropdown-body' === e.target.id) || ('periods-dropdown-body' === e.target.id)) {
                return;
            }
            setDropdownVisible(false);
        };

        window.addEventListener('scroll', handleScroll, true);

        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [dropdownVisible]);


    const getAppliedFilters = () => {
        const applied = {};
        if (vaultStore.selectedTags.length > 0) {
            applied.tags = vaultStore.selectedTags.map(tag => tag.label || tag.name || tag.tag || tag.id);
        }
        if (vaultStore.selectedPeriods.length > 0) {
            applied.periods = vaultStore.selectedPeriods.map(period => period.label || period.period || period.key || period.id);
        }
        if (vaultStore.selectedStatuses.length > 0) {
            applied.statuses = vaultStore.selectedStatuses.map(status => status.label || status.id);
        }
        if (vaultStore.searchValue && vaultStore.searchValue.length > 0) {
            applied.search = vaultStore.searchValue;
        }
        return applied;
    }

    const trackFiltersApplied = () => {
        if (vaultStore.hasActiveFilters) {
            mixpanelTrack('Valut Filters Applied', {
                applied_filters: getAppliedFilters(),
                url: window.location.href,
            })
        }
    }

    const handleRemoveClick = (e) => {
        e.stopPropagation()
        onRemove?.(filter.id)
        setTimeout(() => {
            trackFiltersApplied()
        }, 100)
    }

    const handleVisibleChange = (visible) => {
        setDropdownVisible(visible)
        if (visible && filter.onDataFetch) {
            filter.onDataFetch()
        }
    }

    const handleDrawerOpen = () => {
        setDrawerVisible(true)
        if (filter.onDataFetch) {
            filter.onDataFetch()
        }
    }

    const handleDrawerClose = () => {
        setDrawerVisible(false)
    }

    const handleItemSelect = (item) => {
        filter.onItemSelect?.(item)
        setTimeout(() => {
            trackFiltersApplied()
        }, 100)
    }

    const getDropdownMenu = () => {
        if (!hasDropdown) return null
        switch (filter.id) {
            case 'tags':
                return (
                    <TagsDropdown
                        selectedTags={filter.selectedItems}
                        onTagSelect={handleItemSelect}
                    />
                )
            case 'status':
                return (
                    <StatusDropdown
                        selectedStatuses={filter.selectedItems}
                        onStatusSelect={handleItemSelect}
                    />
                )
            case 'period':
                return (
                    <PeriodDropdown
                        selectedPeriods={filter.selectedItems}
                        onPeriodSelect={handleItemSelect}
                    />
                )
            default:
                return null
        }
    }

    const renderMobileDrawers = () => {
        if (!hasDropdown || uiStore.isDesktopView) return null
        return (
            <>
                {filter.id === 'tags' && (
                    <TagsFilterDrawer
                        isOpen={drawerVisible}
                        onClose={handleDrawerClose}
                        selectedTags={filter.selectedItems}
                        onTagSelect={handleItemSelect}
                    />
                )}
                {filter.id === 'period' && (
                    <PeriodFilterDrawer
                        isOpen={drawerVisible}
                        onClose={handleDrawerClose}
                        selectedPeriods={filter.selectedItems}
                        onPeriodSelect={handleItemSelect}
                    />
                )}
                {filter.id === 'status' && (
                    <StatusFilterDrawer
                        isOpen={drawerVisible}
                        onClose={handleDrawerClose}
                        selectedStatuses={filter.selectedItems}
                        onStatusSelect={handleItemSelect}
                    />
                )}
            </>
        )
    }
    const onClickBtn = ((!disabled && (onClickButton || (hasDropdown && !uiStore.isDesktopView && handleDrawerOpen))) || undefined);
    const buttonContent = (
        <VaultFilterButton
            ref={buttonRef}
            isActive={isActive}
            hasDropdown={hasDropdown}
            data-filter-button="true"
            onClick={onClickBtn}
            style={disabled ? { pointerEvents: 'none', cursor: 'default' } : {}}
        >
            {filter.icon && (
                <FilterIconWrapper>
                    {filter.icon}
                </FilterIconWrapper>
            )}
            {typeof filter.label === 'function' ? filter.label() : filter.label}
            {typeof filter.count === 'number' && ` (${filter.count})`}
            {hasDropdown && (
                <ArrowDownIcon />
            )}
            {onRemove && (
                <CloseButton onClick={handleRemoveClick}>
                    <CloseIcon />
                </CloseButton>
            )}
            {children}
        </VaultFilterButton>
    )

    if (hasDropdown && uiStore.isDesktopView && !disabled) {
        return (
            <>
                <Dropdown
                    overlay={getDropdownMenu()}
                    trigger={['click']}
                    visible={dropdownVisible}
                    onVisibleChange={handleVisibleChange}
                    placement="bottomLeft"
                    getPopupContainer={() => {
                        return document.querySelector('.asset-vault-tab-wrapper') ||
                            document.querySelector('#tabs-content-wrapper') ||
                            document.body
                    }}
                >
                    {buttonContent}
                </Dropdown>
            </>
        )
    }

    return (
        <>
            {buttonContent}
            {renderMobileDrawers()}
        </>
    )
}